import React from 'react'
import { Col, Row, Stack } from 'react-bootstrap'
import { Box, HorizontalStack } from '@ztechapps/webui.util'
import { formatMoney } from '@ztechapps/common.utils'
import { PaymentList } from '../../../components/invoice/PaymentList'
import { ItemList } from '../../../components/invoice/item-list/ItemList'
import { queries } from './graphql'
import { useInvoiceListContext } from './Context'
import type { Invoice } from '@ztechapps/totalmilk-payme.contract'

export const Extension = (props: Partial<Invoice>) => {
  const payment = props.payment
  const { canEdit } = useInvoiceListContext()

  return (
    <div className="m-t-sm">
      <Row>
        <Col md={5}>
          <Box>
            <Box.Header>Payment Details</Box.Header>
            <Box.Body>
              <small>
                <PaymentList items={payment?.items} />
              </small>
              <Stack gap={2} className="flex-fill">
                <HorizontalStack className="justify-content-between">
                  <div>Balance :</div> <div className="font-bold">{formatMoney(payment?.balance)}</div>
                </HorizontalStack>
                <HorizontalStack className="justify-content-between">
                  <div>Total Paid Amount :</div> <div className="font-bold">{formatMoney(payment?.total)}</div>
                </HorizontalStack>
              </Stack>
            </Box.Body>
          </Box>
        </Col>

        <Col md={7}>
          <Box>
            <Box.Body>
              <ItemList
                invoice={props}
                deleteMutationConfig={queries.deleteInvoice_itemsConfig}
                updateMutationConfig={queries.updateInvoice_itemsConfig}
                canEdit={canEdit}
              />
            </Box.Body>
          </Box>
        </Col>
      </Row>
    </div>
  )
}
